package com.essntl.core.supabase.upload

import com.mohamedrejeb.calf.core.PlatformContext
import com.mohamedrejeb.calf.io.KmpFile
import com.mohamedrejeb.calf.io.readByteArray
import io.github.jan.supabase.storage.BucketApi
import io.github.jan.supabase.storage.FileUploadResponse

actual suspend fun BucketApi.upload(
    path: String,
    kmpFile: KmpFile,
    context: PlatformContext,
    upsert: Boolean,
): FileUploadResponse =
    upload(
        path = path,
        data = kmpFile.readByteArray(context),
    ) {
        this.upsert = upsert
    }
